import { render } from "./c-main.vue?vue&type=template&id=255c2a08"
import script from "./c-main.vue?vue&type=script&lang=js"
export * from "./c-main.vue?vue&type=script&lang=js"

import "./c-main.vue?vue&type=style&index=0&id=255c2a08&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__